<template>
  <div class="login comp-login" @keydown.enter.prevent="handleSubmit">
    <transition-group name='img'>
      <template v-for="(item,index) in image.url">
        <div :key="index+1" class="index" v-if="index==image.mark" :style="item"></div>
      </template>
    </transition-group>
    <div class="hidden_page" v-if="hidden_page"></div>
    <div class="login-con">
      <div class="form-con">
        <Row class="form-con-row" type="flex" justify="center">
          <Col>
            <span>{{ show ? $t('l.forget_pwd') : $t('l.login_account') }}</span>
          </Col>
        </Row>
        <template v-if="!show">
          <Form class="form-con-form" label-position="top" ref="loginForm" :model="form"
                :rules="getRules" show-message>
            <FormItem :label="$t('l.mobile_username')" prop="userName" class="FormItem">
              <Input  class="form-input" type="text" v-model="form.userName" :placeholder="$t('l.remark1')"/>
            </FormItem>
            <FormItem :label="$t('l.pwd')" prop="password" class="FormItem">
              <Input  class="form-input" type="password" v-model="form.password" :placeholder="$t('l.remark2')"/>
            </FormItem>
            <FormItem :label="$t('l.captcha')"  class="FormItem" v-if="form.showCaptcha">
              <img :src="form.captchaImgUrl" alt="" class="margin-right-20">
              <Input style="width: 100px" class="form-input" type="text" v-model="form.captcha"/>
            </FormItem>
            <FormItem class="login-button">
              <Button :loading="loginLoading" type="info" long @click.prevent="handleSubmit">{{ $t('l.login') }}
              </Button>
            </FormItem>
          </Form>
        </template>
        <template v-else>
          <!-- 忘记密码 -->
          <Form :rules="getRules" label-position="top" ref="forget" :model="forget"
                class="form-con-form forget-form">
            <FormItem :label="$t('l.mobile')" prop="mobile" class="FormItem">
              <Input  class="form-input" type="text" v-model="forget.mobile" :placeholder="$t('l.remark3')"/>
            </FormItem>

            <FormItem style="margin: 20px 0" :label="$t('l.captcha')" prop="captcha" class="FormItem">
              <div class="form-con-form-div">
                <Input  class="input-captcha" type="text" v-model="forget.captcha" :placeholder="$t('l.remark4')" />
                <Button :style="{backgroundColor:start!=$t('l.get_captcha')?'#aaa':'#5e30c3'}"
                        :disabled="start!=$t('l.get_captcha')"  class="button-captcha" type="info"
                        long @click="getCaptcha">{{ start }}
                </Button>
              </div>
            </FormItem>

            <FormItem  prop="newPwd" :label="$t('l.pwd_new')"  class="FormItem ivu-form-item ivu-form-item-required">
              <Input  :type="passwordType" class="form-input" v-model="forget.newPwd" :placeholder="$t('l.remark5')">
                      <span @click="changeShowPwd" slot="suffix">
                      <template v-if="showPwdContent">
                            <Icon type="ios-eye" />
                      </template>
                      <template v-else>
                            <Icon type="ios-eye-off" />
                      </template>
                    </span>
              </Input>
            </FormItem>

<!--            二次确认密码-->
            <FormItem  style="margin: 20px 0" :label="$t('l.pwd_again')" prop="pwd_again" class="FormItem">
              <Input  :type="passwordType" class="form-input" v-model="forget.pwd_again" :placeholder="$t('l.pwd_again')">
                <span @click="changeShowPwd" slot="suffix">
                      <template v-if="showPwdContent">
                            <Icon type="ios-eye" />
                      </template>
                      <template v-else>
                            <Icon type="ios-eye-off" />
                      </template>
                    </span>
              </Input>
            </FormItem>
            <FormItem class="login-button">
              <Button type="info" :loading="forget.loading" long @click.prevent="submit('forget')">
                {{ $t('l.submit') }}
              </Button>
            </FormItem>
          </Form>
        </template>
        <Row type="flex" justify="space-between" style="padding: 10px 20px;">
          <Col>
            <a href="https://www.diantiyun.com">
              <span class="forget">{{ $t('l.back_official_web') }}</span>
            </a>
          </Col>
          <Col>
            <span class="forget" @click="changeLogin">{{ show ? $t('l.back_login') : $t('l.forget_pwd') }}</span>
          </Col>
        </Row>
      </div>
    </div>
    <div class="login-record">
      <Row type="flex" justify="center">
        <Col>
          <span>Copyright {{ new Date().getFullYear() }} diantiyun.com All Rights Reserved <a
              href="http://www.beian.miit.gov.cn/" >辽ICP备 19006816号-2</a></span>
        </Col>
      </Row>
    </div>
    <div class="qr-codes">
      <div class="qr-code">
        <img src="images/qrcode/download.png">
        <p>{{ $t('l.dty') }}APP</p>
      </div>
    </div>
  </div>
</template>

<script>
import util from '@/libs/util.js';
import { validatePass } from "@/common/validate";
export default {
  data() {
    return {
      passwordType:"password",
      showPwdContent:false,

      // isVerificationShow: false,
      // isVerificationShowForgetPwd:false,
      // puzzleImgList: [
      //   "/images/banner/banner1.jpg",
      //   "/images/banner/banner3.jpg",
      // ],
      imgUrl: null,
      image: {
        mark: 0,
        url: [
          {backgroundImage: "url(images/login1.jpg)"},
          {backgroundImage: "url(images/login2.jpg)"}
        ],
      },
      state: false,
      goods_name: '',
      hidden: false,
      show: false,
      hidden_page: false,
      hidden_pay: false,
      hidden_input: false,
      timestamp: '',
      pay: true,
      uuid: '',
      form: {
        userName: '',
        password: '',
        captcha:"",
        captchaImgUrl:'',
        showCaptcha:false
      },
      forget: {
        mobile: '',
        captcha: '',
        newPwd: '',
        pwd_again: '',
        loading: false
      },
      start: this.$t('l.get_captcha'),
      timer: null,
      loginLoading: false
    };
  },
  created: function () {
    util.clearIntercepter();
    localStorage.removeItem('token');
    this.play();
    let count = localStorage.getItem('flc');  // 失败登录次数
    if(count > 2){
      this.getLoginCaptcha();
      // this.form.showCaptcha = true;
    }
  },
  mounted: function () {
    this.getLoginNum(true); // 刷新时保持次数，不+1，点击登录验证错误时+1
  },
  beforeDestroy() {
    this.loginLoading = false;
    if (this.timer != null) clearInterval(this.timer)
  },
  methods: {
    changeShowPwd(){
      this.showPwdContent = !this.showPwdContent;
      this.passwordType = this.showPwdContent ?"text":"password";
    },
    handleSubmit() {
      this.loginLoading = true;
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          util.ajax.get('/login', {
            params: {
              username: this.form.userName,
              password: this.form.password,
              isApi: true,
              captchaKey:localStorage.getItem('captchaKey'),  // 验证码的key
              code:this.form.captcha  // 验证码
            }
          })
              .then((res) => {
                let loginUser = res.data;  // userinfo
                if (res.code) {
                  // this.getLoginNum(false);
                  let data = res.data;
                  console.log("登录失败data===> :",data);
                  localStorage.setItem('flc',data.count);  // 失败登录次数
                  if(data.count > 2){  // 获取登录失败captcha
                    this.getLoginCaptcha();
                  }else{
                    this.loginLoading = false;
                  }
                } else {
                  // 登录成功，
                  if (loginUser.token) {
                    localStorage.removeItem('loginNum');
                    localStorage.removeItem('flc');
                    localStorage.removeItem("current_community");
                    localStorage.setItem('token', loginUser.token);
                    util.getAuth(0).then(_ => {
                      this.loginLoading = false;
                      this.$router.push({
                        name: 'home_index'
                      });
                    });
                  }
                }
              }).catch(e => {
            this.loginLoading = false;
          });
        }else{
          this.loginLoading = false;
        }
      });
    },

    getLoginNum(flag) {
      if (localStorage.getItem('loginNum') == null) {
        localStorage.setItem('loginNum', 0);
      } else {
        if (flag) {
          localStorage.setItem('loginNum', localStorage.getItem('loginNum'));
        } else {
          localStorage.setItem('loginNum', parseInt(localStorage.getItem('loginNum')) + 1);
        }
      }
      if (parseInt(localStorage.getItem('loginNum')) > 2) {
        this.state = true;
        // this.isVerificationShow = true;
        // if (parseInt(localStorage.getItem('loginNum')) > 3) {
        //   // this.refreshCode();
        // }
      }
    },
    close() {
      this.hidden = !this.hidden,
          this.hidden_page = !this.hidden_page,
          this.pay = true,
          this.hidden_pay = false;
    },
    confirm() {
      this.timestamp = Date.parse(new Date());
      this.pay = !this.pay,
          this.hidden_pay = !this.hidden_pay;
    },
    checked() {
      this.hidden_input = !this.hidden_input;
    },
    getCaptcha() {
      if (!this.forget.mobile) {
        this.$Message.error(this.$t('l.remark3'))
        return
      }
      if(!(/^1[3456789]\d{9}$/.test(this.forget.mobile))){
        this.$Message.error("手机号格式不合法")
        return
      }

      this.handleSuccessForCaptcha();

    },


// 拖拽成功
    handleSuccessForCaptcha() {
      util.ajax.get('/captcha', {
        params: {
          data: {
            company: "【" + this.$t('l.dty_platform') + "】",
            mobile: this.forget.mobile,
            language: localStorage.getItem('language')
          }
        }
      }).then(res => {
        if (!res.code) {
          this.start = 60;
          this.$Message.success(this.$t('l.hint4'));
          var timer = setInterval(() => {
            if (this.start == 0) {
              clearInterval(timer)
              this.start = this.$t('l.get_captcha');
            } else {
              this.start--;
            }
          }, 1000)
        }
      })
    },
    // 拖拽失败
    handleOnError() {
      this.$Message.error("验证失败，请重试");
    },

    handleSuccessForgetPwd(){
      var param = {
        mobile: this.forget.mobile,
        password: this.forget.newPwd,
        captcha: this.forget.captcha
      }
      util.ajax.post('/reset_password', param).then((res) => {
        this.forget.loading = false;
        if (!res.code) {
          this.$Message.success(this.$t('l.edit_success'))
          this.show = !this.show
        }
      });
    },

    submit(name) {
      //   验证两次密码输入是否相等
      if(this.forget.newPwd != this.forget.pwd_again){
        this.$Message.error(this.$t("l.remark14_c"));
        return;
      }

      this.$refs[name].validate((valid) => {
        if (valid) {
          this.forget.loading = true;
          this.handleSuccessForgetPwd();
        }
      });
    },
    autoPlay() {
      if (this.image.mark < this.image.url.length - 1) {
        this.image.mark++;
      } else {
        this.image.mark = 0;
      }
    },
    play() {
      this.timer = setInterval(this.autoPlay, 6000)
    },
    changeLogin() {
      if (!this.show) this.$refs['loginForm'].resetFields();
      else this.$refs['forget'].resetFields();
      this.show = !this.show;
    },

    getLoginCaptcha(){
      util.ajax.get('/login_captcha', { }).then(res =>{
        if(!res.code){
          this.form.showCaptcha = true;
          this.loginLoading = false;
          this.form.captcha = "";
          localStorage.setItem('captchaKey',res.data.captchaKey);
          this.form.captchaImgUrl = res.data.captchaBase64;
        }
      })
    }
  },
  computed: {
    getRules() {
      return {
        userName: [{
          required: true,
          message: this.$t('l.hint1'),
          trigger: 'blur'
        }],
        newPwd: [{
          validator:validatePass ,
          trigger: 'blur',
          required: true,
        }],
        pwd_again: [{
          required: true,
          trigger: 'blur',
          validator:validatePass
        }],
        password: [{required: true, message: this.$t('l.remark9'), trigger: 'blur'}],
        mobile: [{required: true, message: this.$t('l.hint2'), trigger: 'blur'}],
        captcha: [{required: true, message: this.$t('l.hint3'), trigger: 'blur'}],

      }
    },


  },
};

</script>

<style lang="less" scoped>
.puzzle-box {
  position: relative;
  z-index: 8888;
  display: flex;
  justify-content: center;
  top: 40%;
}

.FormItem > :first-child {
  font-size: 14px;
  color: #000;
  font-weight: 600;
}

.img-enter-active,
.img-leave-active {
  transition: all 4s;
}

.img-enter,
.img-leave-to {
  opacity: 0;
}

.img-enter-to,
.img-leave {
  opacity: 1;
}

.login {
  width: 100%;
  height: 100%;
  position: relative;

  .index {
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: center;
    position: absolute;
  }

  &-con {
    position: absolute;
    right: 12%;
    top: 30%;
    width: 20%;
    max-height: 400px;
    overflow-y: auto;
    box-shadow: 10px 10px 999px #fff inset;

    &-header {
      font-size: 16px;
      font-weight: 300;
      text-align: center;
      padding: 30px 0;
    }

    .form-con {
      &-row {
        margin: 20px 0;

        span {
          font-size: 20px;
          font-weight: 500;
          color: #000;
        }
      }

      &-form {
        padding: 0 20px;

        &-div {
          display: flex;
        }
      }

      .form-input {
        width: 100%;
        border: 0;
        //padding-left: 12px;
        box-shadow: 0 0 600px #fff inset;
        background-color: transparent;
      }

      button {
        background-color: #5e30c3;
        color: #fff;
        width: 100%;
        border: 0;
        opacity: 0.85;
        cursor: pointer;
      }

      /*button:hover{*/
      /*box-shadow: 0 0 10px #5e30c3;*/
      /*}*/
    }

    .login-tip {
      font-size: 10px;
      text-align: center;
      color: #c3c3c3;
    }

    .forget {
      font-size: 12px;
      color: #000;
      cursor: pointer;
    }
  }

  &-con::-webkit-scrollbar {
    width: 4px;
  }

  &-con::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: rgba(0, 0, 0, 0.2);
  }

  &-con::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 0;
    background: rgba(0, 0, 0, 0.1);
  }

  &-button {
    margin-bottom: 0;
  }

  .input-captcha {
    //width: 60%;
    border: 0;
    //padding-left: 12px;
    box-shadow: 0 0 600px #fff inset;
    background-color: transparent;
  }

  .button-captcha {
    margin-left: 10%;
  }

  &-record {
    position: absolute;
    bottom: 3%;
    width: 100%;

    span {
      color: #ffffff;
      font-size: 14px;
    }
  }
}

.icon-width {
  width: 15px;
}

#goods {
  float: left;
  padding: 6px;
}

.ad img {
  width: 234PX;
  height: 123px;
}

#goods img:hover {
  transform: scale(1.1);
  cursor: pointer;
}

.hidden_page {
  background: black;
  opacity: 0.4;
  position: fixed;
  z-index: 100000;
  width: 100%;
  height: 100%;
}

.account {
  width: 50%;
  margin-left: 25%;
  position: absolute;
  top: 20%;
  background: white;
  border-radius: 4px;
  z-index: 100001;
}

.pay {
  font-size: 18px;
  text-align: center;
}

.pay div {
  padding: 10px 0;
}

.pay img {
  vertical-align: middle;
}

.account button {
  width: 20%;
  height: 15%;
  font-size: 20px;
}

.xiala {
  text-align: initial;
  margin-left: 203px;
}

.xiala input {
  border: none;
  border-radius: 4px;
  width: 50%;
}

.qr-codes {
  position: fixed;
  left: 2em;
  bottom: 2em;

  .qr-code {
    width: 100px;
    height: 130px;

    img {
      width: 100px;
      height: 100px;
    }

    p {
      color: white;
      text-align: center;
      font-weight: bolder;
      background-color: rgba(0, 0, 0, 0.5);
    }
  }
}
a{
  color: #fff;
}
</style>